export const mailApiEndpoint: string = "https://omuthiya.unicomms.app/mail_php/mail.php?";
